import React, { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import styles from './styles.module.css';

function DataGroup({ title, value, copyable = false }) {
  const [copied, setCopied] = useState(false);

  const canCopy = copyable && value != null && value !== '';

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      /* clipboard unavailable — silently skip */
    }
  };

  return (
    <div className={styles.container}>
      <h3>{title}</h3>
      <div className={styles.valueRow}>
        <p>{value ?? '—'}</p>
        {canCopy && (
          <button
            type='button'
            className={styles.copyBtn}
            onClick={onCopy}
            aria-label={`Copy ${title}`}
            title={copied ? 'Copied' : 'Copy'}
          >
            {copied ? <CheckIcon fontSize='inherit' /> : <ContentCopyIcon fontSize='inherit' />}
          </button>
        )}
      </div>
    </div>
  );
}

export default DataGroup;
